import providersConfig, {
  ProvidersConfigState as providerConfigState,
} from 'containers/LandingPage/store/reducers/providersConfig.reducer';
import { connect, ConnectedProps } from 'react-redux';
import * as fromDucks from 'containers/LandingPage/store/ducks/providersConfig.ducks';

export interface ProvidersState {
  providersConfig: providerConfigState;
}

export const providerConfigReducer = providersConfig;
export const connector = connect((state: ProvidersState) => ({ state }), fromDucks);
export type PropsFromRedux = ConnectedProps<typeof connector>;
